/* tslint:disable */

declare var Object: any;
export interface ExpenseCodeInterface {
  "LastModifiedById"?: string;
  "LastModifiedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "OwnerId"?: string;
  "Name"?: string;
  "sfdcId"?: string;
  "Expense_Description__c"?: string;
  "IsDeleted"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class ExpenseCode implements ExpenseCodeInterface {
  "LastModifiedById": string;
  "LastModifiedDate": Date;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "OwnerId": string;
  "Name": string;
  "sfdcId": string;
  "Expense_Description__c": string;
  "IsDeleted": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ExpenseCodeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ExpenseCode`.
   */
  public static getModelName() {
    return "ExpenseCode";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ExpenseCode for dynamic purposes.
  **/
  public static factory(data: ExpenseCodeInterface): ExpenseCode{
    return new ExpenseCode(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ExpenseCode',
      plural: 'ExpenseCodes',
      path: 'ExpenseCodes',
      idName: 'id',
      properties: {
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Expense_Description__c": {
          name: 'Expense_Description__c',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
